/** Converts #RRGGBB (or RRGGBB) to Tailwind/shadcn HSL components: "H S% L%" */
export function hexToHsl(hex: string): string {
  const normalized = hex.replace('#', '').slice(0, 6);
  if (normalized.length !== 6) return '217 72% 15%';

  const r = parseInt(normalized.slice(0, 2), 16) / 255;
  const g = parseInt(normalized.slice(2, 4), 16) / 255;
  const b = parseInt(normalized.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / d + 2) / 6;
        break;
      case b:
        h = ((r - g) / d + 4) / 6;
        break;
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function getRelativeLuminance(hex: string): number {
  const normalized = hex.replace('#', '').slice(0, 6);
  if (normalized.length !== 6) return 0;

  const channels = [0, 2, 4].map((i) => {
    const c = parseInt(normalized.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
}

export function getContrastForeground(hex: string): string {
  return getRelativeLuminance(hex) > 0.5 ? '0 0% 9%' : '0 0% 98%';
}

/** Returns #ffffff or #0f172a for readable text on a solid background. */
export function getContrastHex(hex: string): string {
  return getRelativeLuminance(hex) > 0.5 ? '#0f172a' : '#ffffff';
}

/** CSS color-mix() helper — mixes `mixColor` at `percentage` into `baseColor`. */
export function colorMix(baseColor: string, mixColor: string, percentage: string): string {
  return `color-mix(in srgb, ${mixColor} ${percentage}, ${baseColor})`;
}
